<template>
  <Layout title="Clausify">
    <div class="container">
      <div class="row">
        <h1>Marketing</h1>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
  components: {
    Layout,
  },
};
</script>
